import IconWarning from '@apollo/icons/large/IconWarning.svg';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React from 'react';

interface Props {
  /**
   * Determines if the modal is open or not
   */
  isOpen: boolean;
  /**
   * Callback called when we attempt to close the modal
   */
  onClose: () => void;
}

/**
 * Modal to display when the variant has no url set and the user does not have
 * permission to change it.
 */
export const CannotRunWithoutVariantEndpointModal = ({
  isOpen,
  onClose,
}: Props) => (
  <Modal isOpen={isOpen} onClose={onClose} size="lg">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        <ModalTitle className="flex items-center gap-4">
          <IconWarning className="size-8 text-neutral" />
          Oops! Looks like you haven’t set the URL for your graph yet.
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        We need to know where your graph is located to know where to send your
        query. Unfortunately, only an administrator can set your Graph URL.
        Please contact your account’s administrator to set this so you can run
        your queries with Explorer.
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose} type="button">
          Close
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
